import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api_adiantamento';
import apidesp from '../../services/api_despesas';
import apiRPA from '../../services/api_rpa';
import { TiVendorAndroid } from "react-icons/ti";
import moment from 'moment';
import styles from "./styles.module.css";

export default function Rpa() {

    const [empresas, setEmpresas] = useState({
        items: [
        ],
        selectItem: 0
    });

    const [force, setForce] = useState(false)

    const [time, settime] = useState({});

    const [rpa, setRpa] = useState([]);

    const [statusIntegracao, setStatusIntegracao] = useState({});

    useEffect(() => {
        apidesp.get(`/despesa/statusintegracao`).then(function (response) {
            if (response.data) {
                setStatusIntegracao(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, [time]);


    useEffect(() => {
        api.get(`/empresa`).then(function (response) {
            setEmpresas({
                items: [
                ],
                selectItem: 0
            })
            if (response.data) {
                const emps = Object.assign([], empresas);
                response.data.forEach(emp => {
                    if (emp.id === 1 || emp.id === 2 || emp.id === 3 || emp.id === 5 || emp.id === 6) {
                        var emppush = {};
                        emppush.id = emp.id;
                        emppush.text = emp.descempresa;
                        emps.items.push(emppush);
                    }
                });
                setEmpresas(emps);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, []);

    useEffect(() => {
        setTimeout(function () {
            settime(time + 1);
        }, 3000);
    }, [time]);

    useEffect(() => {
        api.get(`/rpa`).then(function (response) {
            if (response.data) {
                if (!force) {
                    setRpa(response.data)
                }
                setForce(false)
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }, [time]);

    function rodarRpa(empresa) {


        const rpaassigned = Object.assign([], rpa);
        var selectedrpa = rpaassigned.find(item => parseInt(item.empresa_id) === parseInt(empresa))
        setForce(true)
        selectedrpa.status = 1
        setRpa(rpaassigned)
        try {
            apiRPA.get(`/rpadespesas/empresa/${empresa}`).then(function (response) {

            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        } finally {

        }
    }

    function renderRodar(r) {
        if ((statusIntegracao.status_orcamento === 0 && statusIntegracao.status_syscusto === 0) || (statusIntegracao.status_orcamento === 2 || statusIntegracao.status_syscusto === 2)) {
            if (r.status === 0) {
                return (
                    <td onClick={() => rodarRpa(r.empresa_id)} ><TiVendorAndroid size="25" color='green' className="tb-contas" /></td>
                )
            } else {
                return (
                    <td>
                        <div className='spinner'></div>
                    </td>

                )
            }
        } else {
            return (
                <td>

                </td>
            )
        }
    }

    function renderRow() {
        return (
            rpa.map((r, index) => {
                return (
                    <tr key={index}>
                        {renderRodar(r)}
                        <td>{(r.empresa_id === 3 ? '3-4-7-8' : r.empresa_id)}</td>
                        <td>{(r.status === 0 ? 'PARADO' : 'RODANDO')}</td>
                        <td>{r.erro}</td>
                        <td>{moment(r.updatedAt).utc().format('DD/MM/YYYY HH:mm:ss')}</td>
                    </tr>
                )
            })
        )

    }

    function handleIntegrar() {
        var obj = Object.assign({}, statusIntegracao)
        obj.status_orcamento = 1;
        setStatusIntegracao(obj);
        apidesp.get(`/despesa/integracao`).then(function (response) {
            if (response.data) {
                console.log('aqui', response.data)
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderRodarIntegracao() {
        if ((statusIntegracao.status_orcamento === 0 && statusIntegracao.status_syscusto === 0) || (statusIntegracao.status_orcamento === 2 || statusIntegracao.status_syscusto === 2)) {
            return (
                <input type="button" value="INTEGRAR ORÇAMENTO/SYSCUSTO" className='btn-sm btn-primary' onClick={() => handleIntegrar()} />
            )
        } else {
            return (
                <div className={styles.divloading}>
                    <div className={styles.loading}></div>
                </div>
            )
        }
    }

    function renderStatusIntegracao(status) {
        if (status === 0) {
            return (
                <td>FINALIZADO</td>
            )
        }
        if (status === 1) {
            return (
                <td>RODANDO</td>
            )
        }
        if (status === 2) {
            return (
                <td>ERRO</td>
            )
        }

    }

    return (
        <div className="container-lg">
            <Header title="RPA CADASTRO DE DESPESAS" />
            <h3><b>INTEGRAÇÃO</b></h3>
            {renderRodarIntegracao()}
            <table className='table table-sm'>
                <thead>
                    <tr>
                        <th>INTEGRAÇÃO</th>
                        <th>STATUS</th>
                        <th>ULTIMA ATUALIZAÇÃO</th>
                        <th>MENSAGEM DE ERRO</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>ORÇAMENTO</td>
                        {renderStatusIntegracao(statusIntegracao.status_orcamento)}
                        <td>{moment(statusIntegracao.dt_hr_orcamento).format('DD/MM/YYYY HH:mm:ss')}</td>
                        <td>{statusIntegracao.msg_erro_orcamento}</td>
                    </tr>
                    <tr>
                        <td>SYSCUSTO</td>
                        {renderStatusIntegracao(statusIntegracao.status_syscusto)}
                        <td>{moment(statusIntegracao.dt_hr_syscusto).utc().format('DD/MM/YYYY HH:mm:ss')}</td>
                        <td>{statusIntegracao.msg_erro_syscusto}</td>
                    </tr>
                </tbody>

            </table>
            <hr />
            <h3><b>RPA</b></h3>
            <table className='table table-sm'>
                <thead>
                    <tr>
                        <th>RODAR</th>
                        <th>EMPRESA</th>
                        <th>STATUS</th>
                        <th>ERRO</th>
                        <th>ULTIMA ATUALIZAÇÃO</th>
                    </tr>
                </thead>
                <tbody>
                    {renderRow()}
                </tbody>
            </table>
        </div>
    )
}